module.exports = __webpack_public_path__ + "static/media/TowerIcon.a227036c.svg";